import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import useSnackbar from '@/lib/hooks/useSnackBar';
import useGetAllSearchParams from '@/lib/hooks/useGetAllSearchParams';
import { detectPlatform, isMobileOrTablet, Platform } from '@/lib/utils';

const link = {
  [Platform.Android]: 'https://play.google.com/store/apps/details?id=ai.rentout.rentout',
  [Platform.Ios]: 'https://apps.apple.com/app/rentout-ai/id6503697390',
};

const useRedirectToApp = () => {
  const t = useTranslations('Index');
  const { showErrorSnackbar } = useSnackbar();
  const searchParams = useGetAllSearchParams();

  let BranchSDK: any = null;

  // Only import branch-sdk client-side
  useEffect(() => {
    import('branch-sdk').then((mod) => {
      BranchSDK = mod.default;
    });
  }, []);

  const goToApp = (platform: Platform) => {
    if (!isMobileOrTablet()) return window.location.href = link[platform];

    const detectedPlatform = detectPlatform();

    if (detectedPlatform && platform !== detectedPlatform) return window.location.href = link[platform];

    handleBranchRedirection();
  };

  const handleBranchRedirection = () => {
    if (!searchParams?.awc) return window.location.href = 'https://1447t.app.link/OfsOW6fkqSb';

    if (!BranchSDK) {
      // branch-sdk not ready yet
      return window.location.href = 'https://1447t.app.link/OfsOW6fkqSb';
    }

    BranchSDK.link({ data: { awc: searchParams?.awc } }, (branchError: any, deepLink: string) => {
      if (!deepLink) return showErrorSnackbar(t('error'));
      window.location.href = deepLink;
    });
  };

  return { goToApp, handleBranchRedirection };
};

export default useRedirectToApp;
